import React, { useMemo, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Scrollbars } from "react-custom-scrollbars-2";

import { GAOrgDetailTableRow } from "../components";
import {
  GAOrganizationsDetailTableHeadCells,
  GeneralAdminRoutes,
  getComparator,
  stableSort,
} from "../../../../../constants";
import { useNavigate } from "react-router-dom";
import TableHeadComponent from "../../../../../common/TableHeadComponent";

export default function GAOrgDetailTable({
  selected,
  setSelected,
  orgDetail,
  reports,
  detailsPageReports,
}) {
  const navigate = useNavigate();
  const scrollbarsRef = useRef(null);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("name");
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const isSelected = (id) => selected.indexOf(id) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page - 1 > 0
      ? Math.max(0, (1 + page - 1) * rowsPerPage - reports.length)
      : 0;

  const visibleRows = useMemo(
    () => stableSort(reports, getComparator(order, orderBy)),
    [order, orderBy, page, rowsPerPage, reports]
  );

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = visibleRows.map((n) => n.id);
      // const newSelected = areaData.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClickRow = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };
  // console.log("row", row);

  return (
    <Box sx={mainBoxStyles}>
      {/* <Scrollbars
        style={scrollbar}
        autoHide={true}
        ref={scrollbarsRef} // Assign the ref to Scrollbars instance
        renderThumbVertical={({ style, ...props }) => (
          <div
            {...props}
            style={{
              ...style,
              ...scrollbarprops,
            }}
          />   
        )}
      > */}
      <Paper sx={mainContainerStyles}>
        <TableContainer style={tableContainerStyles}>
          <Table
            stickyHeader
            aria-labelledby="tableTitle"
          >
            <TableHeadComponent
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={visibleRows.length}
              TableHeadData={GAOrganizationsDetailTableHeadCells}
              detailsPageReports={detailsPageReports && detailsPageReports}
            />
            <TableBody>
              {visibleRows.map((row, index) => {
                const isItemSelected = isSelected(row.id);
                const labelId = `enhanced-table-checkbox-${index}`;
                const numberType = index % 2 == 0;

                return (
                  <GAOrgDetailTableRow
                    // isItemSelected={isItemSelected}
                    row={row}
                    handleClickRow={handleClickRow}
                    numberType={numberType}
                    labelId={labelId}
                    orgDetail={orgDetail}
                    key={index}
                    handleNavigateToDetails={() => {
                      navigate(GeneralAdminRoutes.organizationDetails, {
                        state: { organizationData: row },
                      });
                    }}
                  />
                );
              })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: 53 * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}


            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      {/* </Scrollbars> */}
    </Box>
  );
}

const mainBoxStyles = {
  width: "100%",
  paddingRight: 1,
  border: "none",
  boxShadow: "none",
};

const mainContainerStyles = {
  // width: "100%",
  // mb: 2,
  // border: "none",
  // boxShadow: "none",
  // pr: 1,
  maxWidth: "100%",
  mb: 1,
  border: "none",
  boxShadow: "none",
  mt: 1,
};

const tableContainerStyles = {
  // border: "none",
  // boxShadow: "none",
  // width: "122%",
  // marginTop: 20,
  border: "none",
  boxShadow: "none",
  maxHeight: "65vh",
};

// const scrollbar = { maxWidth: "100%", height: "500px", marginLeft: "auto" };
// // const scrollbar = { width: "100%", height: "500px", marginLeft: "auto" };
// const scrollbarprops = {
//   width: "4px",
//   backgroundColor: "#00A7CD",
//   borderRadius: "2px",
// };
